/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  position: relative;
  text-align: left;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  background: #fff;
}

.item-list {
  position: absolute;
  white-space: nowrap;
  box-shadow: 0 0 0.2142857143rem rgba(0, 0, 0, 0.3);
  z-index: 8;
  top: 0.3571428571rem;
  background: #FFFFFF;
  background: var(--davinci-color-background-08dp, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}

:host(:not([left])) .item-list {
  right: calc(100% + 2px);
}

:host([left]) .item-list {
  left: calc(100% + 2px);
}

:host .item-container {
  position: relative;
  margin: 0;
}

:host(:not([disabled])) .item-container:hover {
  cursor: pointer;
}
:host(:not([disabled])) .item-container:hover > .hover-box {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}

:host(:not([disabled])[open]) .item-container > .hover-box {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
  border-color: #009DF4;
  border-color: var(--davinci-color-primary-light, #009DF4);
}

:host([disabled]) .item-container:hover {
  cursor: pointer;
}
:host([disabled]) .item-container:hover > .hover-box {
  cursor: not-allowed;
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
  border-color: #B1B8BC;
  border-color: var(--davinci-color-text-disabled, #B1B8BC);
}

.hover-box {
  display: flex;
  flex-grow: 1;
  align-items: center;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-08dp, #FFFFFF);
  border-left: 0.4285714286rem solid rgba(255, 255, 255, 0);
}

davinci-icon,
davinci-icon-ref {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}

:host([disabled]) davinci-icon,
:host([disabled]) davinci-icon-ref {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

.item-icon {
  margin-left: 0.7142857143rem;
}
.item-icon.icon-only {
  margin: 0.8571428571rem 1.1428571429rem 0.8571428571rem 0.7142857143rem;
}

.label {
  display: inline-block;
  flex-grow: 2;
  padding: 0.8571428571rem 1.1428571429rem 0.8571428571rem 0.7142857143rem;
  line-height: 1.1428571429rem;
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
}

:host([disabled]) .label {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([icon-placeholder]) .label,
:host([icon]) .label {
  padding-left: 0.5714285714rem;
}

.submenu-indicator {
  flex-grow: 0;
  display: inline-block;
  margin-right: 0.8571428571rem;
  width: 1.7142857143rem;
  height: 1.9571428571rem;
}
.submenu-indicator.collapse {
  display: none;
  height: 0;
  margin: 0;
  width: 0;
}

:host([hidden]) {
  display: none;
}`;
export { style };
